export dogWithFlower from "./dog-with-flower.jpg";
export oops404 from "./oops-404.jpg";
export paper from "./paper.png";
export rock from "./rock.png";
export scissors from "./scissors.png";
